export const DEFAULT_VACATION_LIST = [
  { label: '연차', value: null },
]

export const DEFAULT_VACATION_DAY_TYPE_LIST = [
  { label: '종일', value: 'all' },
  { label: '반차', value: 'half' },
  { label: '반반차', value: 'quarter' },
  { label: '휴일', value: 'none' },
]